import { action, observable } from 'mobx'
import { LOGIN } from '../../routes/app-routes'
import { goTo } from '../../utils/router-utils'

export class UserStore {
    @observable
    authorized = true

    @action
    resetAuthorization = () => {
        this.authorized = false
        goTo(LOGIN)
    }
}
